export const WTAI_CHECK_DESTINATIONS = {
  WEBSOCKET: 'wss',
  WBE: 'wpt',
  PLAGIARISM: 'plagiarism',
  PUSHER: 'wsx',
}

export const PLAGIARISM_CHECK_TIMEOUT = 600000
export const GRAMMAR_CHECK_TIMEOUT = 300000

export const GRAMMAR_CHECK_START_FAIL_MESSAGE = 'WTAI_CHECK_START_FAIL'
export const PLAGIARISM_CHECK_START_FAIL_MESSAGE = 'WTAI_PLAGIARISM_CHECK_START_FAIL'
export const PARTIAL_PLAGIARISM_CHECK_START_FAIL_MESSAGE =
  'WTAI_PARTIAL_PLAGIARISM_CHECK_START_FAIL'

export const PLAGIARISM_CHECK_TIMEOUT_MESSAGE = 'PLAGIARISM_CHECK_TIMEOUT'

export const FF_COOKIE_NAME = 'al_ff'
export const FF_GRAPHQL_VAR_NAME = 'wtFF'



// WEBPACK FOOTER //
// ./src/state/checks/constants.ts